/* eslint-disable no-unused-vars */
import { articles, captcha, selectedArticles, payment, internalId } from "./selectors";
import * as types from "./types";
import API from "../../services/api";
import cloneDeep from "lodash/cloneDeep";
import { contributorData, taxPayerData } from "../Users/selectors";
import { calSubTot, checkNaN, getReformatItem, sortElements } from "./functions";
import { redirectTo } from "../../utils/functions";
import { loadingStart, failed } from "../General/actions";

export function loadArticles(articles, message) {
  return {
    type: types.LOAD_ARTICLES,
    articles,
    message,
  };
}

export function selectedItems(articles) {
  return {
    type: types.SELECTED_ITEM,
    articles,
  };
}

export function generateTotal(value) {
  return {
    type: types.GENERATE_TOTAL,
    value,
  };
}

export function loadTotal(total) {
  return {
    type: types.LOAD_TOTAL,
    total,
  };
}

export function loadSubTotal(articles, selArticles) {
  return {
    type: types.LOAD_SUB_TOTAL,
    articles,
    selArticles,
  };
}

export function loadPaymentRequest(payment) {
  return {
    type: types.LOAD_PAYMENT_REQUEST,
    payment,
  };
}

export function loadCaptcha(captcha) {
  return {
    type: types.LOAD_CAPTCHA,
    captcha,
  };
}

export function loadInternalId(internalId) {
  return {
    type: types.LOAD_INTERNAL_ID,
    internalId,
  };
}

export function resetStore() {
  return {
    type: types.RESET_STORE,
  };
}

export const modifyValues = (row, field, value) => {
  return (dispatch, getState) => {
    const arts = articles(getState());
    const selArts = selectedArticles(getState());
    const copyArts = cloneDeep(arts);
    const copySelArts = cloneDeep(selArts);
    copyArts.map((art) => {
      art.subRows.map((sub) => {
        if (sub.amount === null && sub.articleName === null) {
          sub.subRows.map((i) => {
            if (i.id === row.original.id) {
              i[field] = checkNaN(value);
            }
          });
        } else {
          if (sub.id === row.original.id) {
            sub[field] = checkNaN(value);
          }
        }
      });
    });
    if (copySelArts.some((art) => art.id === row.original.id)) {
      copySelArts.map((i) => {
        if (i.id === row.original.id) {
          i[field] = checkNaN(value);
        }
      });
      dispatch(selectedItems(copySelArts));
    }
    dispatch(loadArticles(copyArts));
    dispatch(calSubTotal(row.original.id));
  };
};

export const selectedItem = (item) => {
  return (dispatch, getState) => {
    const selArts = selectedArticles(getState());
    const copySelArts = cloneDeep(selArts);
    if (copySelArts.length === 0) {
      copySelArts.push(getReformatItem(item));
      dispatch(selectedItems(copySelArts));
      return null;
    }
    if (copySelArts.some((art) => art.id === item.id)) {
      const result = copySelArts.filter((i) => i.id !== item.id);
      dispatch(selectedItems(result));
    } else {
      copySelArts.push(getReformatItem(item));
      dispatch(selectedItems(copySelArts));
    }
  };
};

export const deleteItem = (id) => {
  return (dispatch, getState) => {
    const selArts = selectedArticles(getState());
    const copySelArts = cloneDeep(selArts);
    if (copySelArts.some((art) => art.id === id)) {
      const result = copySelArts.filter((i) => i.id !== id);
      dispatch(selectedItems(result));
    }
  };
};

export const calSubTotal = (id) => {
  return (dispatch, getState) => {
    const arts = articles(getState());
    const selArts = selectedArticles(getState());
    const copyArts = cloneDeep(arts);
    const copySelArts = cloneDeep(selArts);
    copyArts.map((art) => {
      art.subRows.map((sub) => {
        if (sub.amount === null && sub.articleName === null) {
          sub.subRows.map((i) => {
            if (i.id === id) {
              i.subtotal = calSubTot(i);
              dispatch(loadArticles(copyArts));
            }
          });
        } else {
          if (sub.id === id) {
            sub.subtotal = calSubTot(sub);
            dispatch(loadArticles(copyArts));
          }
        }
      });
    });
    copySelArts.map((art) => {
      if (art.id === id) {
        art.subtotal = calSubTot(art);
      }
    });
    dispatch(selectedItems(copySelArts));
  };
};

export const calTotal = () => {
  return (dispatch, getState) => {
    const selArts = selectedArticles(getState());
    let total = 0;
    if (selArts.length === 0) {
      dispatch(loadTotal(0));
      return null;
    }
    selArts.map((i) => {
      total = total + i.subtotal;
    });
    dispatch(loadTotal(parseFloat(total).toFixed(2)));
  };
};

export const setUrgent = (row) => {
  return (dispatch, getState) => {
    const arts = articles(getState());
    const selArts = selectedArticles(getState());
    const copyArts = cloneDeep(arts);
    const copySelArts = cloneDeep(selArts);
    copyArts.map((art) => {
      art.subRows.map((sub) => {
        if (sub.amount === null && sub.articleName === null) {
          sub.subRows.map((i) => {
            if (i.id === row.original.id) {
              i.urgent = !i.urgent;
            }
          });
        } else {
          if (sub.id === row.original.id) {
            sub.urgent = !sub.urgent;
          }
        }
      });
    });
    if (copySelArts.some((art) => art.id === row.original.id)) {
      copySelArts.map((i) => {
        if (i.id === row.original.id) {
          i.urgent = !i.urgent;
        }
      });
      dispatch(selectedItems(copySelArts));
    }
    dispatch(loadArticles(copyArts));
  };
};

/* Requests*/

export function getArticles() {
  return async (dispatch) => {
    dispatch(loadingStart());
    try {
      const response = await API.concept.getArticles();
      dispatch(loadArticles(sortElements(response.data)));
    } catch (e) {
      dispatch(failed("Error al cargar los articulos"));
    }
  };
}

export function paymentRequest(data) {
  return async (dispatch) => {
    dispatch(loadingStart());
    try {
      const response = await API.concept.generatePaymentRequest(data);
      dispatch(loadPaymentRequest(response.data));
      dispatch(savePayment(true));
    } catch (e) {
      dispatch(failed(e.response.data[Object.keys(e.response.data)[0]]));
    }
  };
}

export function savePayment(redirect) {
  return async (dispatch, getState) => {
    const captchaToken = captcha(getState());
    const payer = taxPayerData(getState());
    const contributor = contributorData(getState());
    const taxes = selectedArticles(getState());
    const paymentHeli = payment(getState());
    const internal_id = internalId(getState());
    const data = {
      recaptchaResponse: captchaToken,
      internalId: internal_id,
      payment: paymentHeli,
      taxes: taxes,
      contributor: contributor,
      payer: payer,
    };
    dispatch(loadingStart());
    try {
      const response = await API.concept.savePayment(data);
      if (redirect) {
        redirectTo(data.payment.checkout_url);
      }
    } catch (e) {
      dispatch(failed("Error al generar la solicitud de pago"));
    }
  };
}

export function getPaymentSummary(id) {
  return async (dispatch) => {
    dispatch(loadingStart());
    try {
      const response = await API.concept.getPaymentSummary(id);
      dispatch(selectedItems(response.data.taxes));
      dispatch(loadPaymentRequest(response.data.payment));
    } catch (e) {
      dispatch(failed("Error en resumen de pago"));
    }
  };
}

export function getPaymentDetail(interId, data) {
  return async (dispatch) => {
    dispatch(loadingStart());
    try {
      const heliResponse = await API.concept.generatePaymentRequest(data);
      dispatch(loadPaymentRequest(heliResponse.data));
      await dispatch(savePayment());
      dispatch(downLoadPdf(interId));
    } catch (e) {
      dispatch(failed("Error al cargar el detalle del pago"));
    }
  };
}

export function downLoadPdf(interId) {
  return async (dispatch) => {
    dispatch(loadingStart());
    try {
      const pdfResponse = await API.pdfs.getPaymentDetail(interId);
      const url = URL.createObjectURL(pdfResponse);
      const link = document.createElement("a");
      link.href = url;
      link.download = pdfResponse.filename;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (e) {
      dispatch(failed("Error al descargar PDF"));
    }
  };
}
